/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import DashboardSidebar from '@/components/DashboardSidebar/DashboardSidebar';
import IntroductionPhase from '@/components/IntroductionPhase';
import LearnMore from '@/components/LearnMore/LearnMore';
import { useAppSelector } from '@/hooks';
import { createStyles } from '@/utils/styles';
import { ResponsiveGridLayout } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import React from 'react';
import Final from './Final';
import MainArea from './MainArea';

const PageComponent: React.FC = () => {
    const productList = useAppSelector(state => state.productList);
    const { currentStep, isFinalPage, currentPhase } = productList;
    const isIntroductionPhase = currentPhase.displayOrder === 1;

    if (isIntroductionPhase) return <IntroductionPhase />;

    return (
        <section style={styles.wrapper} id="content" data-sap-ui-fastnavgroup="true">
            {isFinalPage ? (
                <Final />
            ) : (
                <ResponsiveGridLayout
                    columnsS={1}
                    columnsM={1}
                    columnsL={4}
                    columnsXL={5}
                    columnSpanL={2}
                    columnSpanXL={3}
                    columnGap="1rem"
                    style={{ alignItems: 'start', marginBottom: '50px' }}
                >
                    <DashboardSidebar gridColumn="span 1" />
                    <MainArea />
                    <div style={{ maxWidth: '340px', gridColumn: 'span 1' }} data-sap-ui-fastnavgroup="true">
                        {currentStep.learnMoreContent && <LearnMore />}
                    </div>
                </ResponsiveGridLayout>
            )}
        </section>
    );
};

const styles = createStyles({
    wrapper: {
        padding: ThemingParameters.sapContent_Space_S,
        paddingBottom: ThemingParameters.sapContent_Space_XL,
        paddingLeft: ThemingParameters.sapContent_Space_XL,
        paddingRight: ThemingParameters.sapContent_Space_XL,
    },
});

export default PageComponent;
